import clsx from "clsx";
import { useT } from "~/util/Lang";
import css from "./Footer.module.css";
import { DiscordLink } from "./links/Socials";

export function Footer() {
  const t = useT();

  return (
    <footer className={clsx(css.root, "container")}>
      <div className={css.footerInfo}>
        <div>
          <span style={{ color: "#eab308" }}>L2hub.info</span>
          <span style={{ color: "#b7b7b7" }}>
            {" "}
            -{" "}
            {t({
              en: "Information site about the game Lineage 2",
              ru: "Информационый сайт по игре Lineage 2",
            })}
            .{" "}
          </span>
        </div>
        <div>
          {t({
            en: "All exclusive rights, rights to the Game and/or its elements belong to NCsoft. Official website of the game: 4game.com.",
            ru: "Все исключительные права, права на Игру и/или ее элементы принадлежат NCSoft. Официальный сайт игры: 4game.com.",
          })}
        </div>
      </div>
      <div className={css.socials}>
        <DiscordLink />
      </div>
    </footer>
  );
}
